import { Box } from '@mui/material';
import { useFormContext } from 'react-hook-form';
import { RHFSelectPaginationSingle } from '../../code-manage/code-create/components/RHFSelectPaginationSingle';
import { getListSubject } from '../../news-subject/subject-list/service';
import { getListNews } from '../../news/news-list/service';
import { ROUTE_DATA } from '../constants';
import { RHFSelectPaginationSubject } from './RHFSelectPaginationSubject';

export default function ParamsField() {
  const { watch } = useFormContext();

  return (
    <Box width={'100%'}>
      {watch('route') === ROUTE_DATA.NEWS && (
        <RHFSelectPaginationSingle
          name="params"
          placeholder={'Chọn bài viết'}
          getAsyncData={getListNews}
          error={false}
        />
      )}
      {watch('route') === ROUTE_DATA.SUBJECT && (
        <RHFSelectPaginationSubject
          name="params"
          placeholder={'Chọn chủ đề'}
          getAsyncData={getListSubject}
          error={false}
        />
      )}
    </Box>
  );
}
